import React from 'react';
const PhraseContext = React.createContext({
    phrase: (key, defaultPhrase) => defaultPhrase,
});
export default PhraseContext;
